import { GroupsApi } from '../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useParams } from 'react-router-dom';
import { getApiConfiguration } from '../../../common';

export const useDeleteGroup = (
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse>,
    'mutationFn'
  >,
): UseMutationResult<AxiosResponse<void>, ErrorResponse, void> => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const groupsApi = new GroupsApi(getApiConfiguration());
  const { id } = useParams<{ id: string }>();

  return useMutation(
    () => groupsApi.deleteGroup(tenantId, id),
    options,
  );
};
